import React from "react";
import { Popover } from "@headlessui/react";

export type CaPopoverProps = {
  children: React.ReactNode;
  content: React.ReactNode;
};

function CaPopover({ children, content }: CaPopoverProps) {
  return (
    <Popover>
      <Popover.Button>
        {children}
      </Popover.Button>

      <Popover.Panel className='absolute z-10 bg-white rounded-base p-4 shadow-xl'>{content}</Popover.Panel>
    </Popover>
  );
}

export default CaPopover;
